import throttle from 'lodash.throttle';
import 'jquery-mousewheel';

import vars from '../helpers';
import test from './test';

const KEY_SPACE = 32;
const KEY_HOME = 36;
const KEY_END = 35;
const KEY_PAGE_UP = 33;
const KEY_PAGE_DOWN = 34;
const KEY_ARROW_TOP = 38;
const KEY_ARROW_BOTTOM = 40;

const $overlay = $('.overlay');
const $overlayBg = $overlay.find('.overlay__bg');
const $overlayBgVideo = $overlayBg.find('video').get(0);
const $overlayImage = $overlay.find('.overlay__image');
const $overlayIntro = $overlay.find('.overlay__intro');
const $overlayIntroImage = $overlayIntro.find('.overlay__img');

const $homeScroll = $('.home-scroll');
const $homeScreen = $('.home-screen');

const $headerLink = $('.header__link');
const $asideNext = $('.aside__next, .professions__bottom, .discoveries__bottom');
const $asideBack = $('.aside__back');
const $achievementsTextLink = $('.achievements__circle--test');
const $beginButton = $('.begin__on, .begin__off');

let isAnimating = true;
let isAnimatingNext = false;
let isAnimatingTest = false;
let isScroll = true;
let scrollStep = innerHeight;
let scrollTimeout = null;
let scrollTimeoutMs = 0.2;
let canScroll = true;
let touchStartY = 0;
let touchEndY = 0;
let touchPach = 50;

const controlsNext = [KEY_SPACE, KEY_END, KEY_PAGE_DOWN, KEY_ARROW_BOTTOM];
const controlsPrev = [KEY_HOME, KEY_PAGE_UP, KEY_ARROW_TOP];

function changeUrl() {
	const screenName = $homeScreen.filter('.is-current').data('name');

	if (typeof screenName === 'undefined') {
		return;
	} else if (screenName === '') {
		history.replaceState(null, null, location.pathname + location.search);

		return;
	}

	location.hash = screenName;
}

function canInteract(flag) {
	if (!flag) {
		isScroll = false;

		vars.$html.attr('data-pointer', true);
	} else if (flag) {
		isScroll = true;

		vars.$html.attr('data-pointer', false);
	}
}

function screenTransitionWithoutOverlay(screenIndex) {
	return new Promise((resolve) => {
		const $screenCurrent = $homeScreen.filter('.is-current');
		const $screenNext = $homeScreen.filter(`[data-screen="${screenIndex}"]`);

		const screenPosition = -($screenNext.offset().top - $homeScroll.offset().top);
		const screenCurrentIndex = +$screenCurrent.data('screen');

		if (screenIndex === 1) {
			$('.entrance').scrollTop(0, 0);
		}

		if (screenIndex === 6) {
			test.enter(1.1);
		}

		let tl = gsap
			.timeline({
				onComplete() {
					$homeScreen.removeClass('is-current');
					$screenNext.addClass('is-current');

					changeUrl();

					if (screenCurrentIndex === 6 && screenIndex !== 6) {
						test.leave();
						isAnimating = false;
					}


					if (screenIndex === 1 && vars.isMobile()) {
						isAnimating = false;
					}

					if (screenIndex === 5) {
						vars.$document.on('professions-slider-update');
					}

					if (screenIndex === 3) {
						vars.$document.trigger('discoveries-slider-play');
					} else {
						vars.$document.trigger('discoveries-slider-stop');
					}

					if (screenIndex === 2 || vars.isMobile()) {
						vars.$document.trigger('achievements-slide-first');
					}

					if (screenCurrentIndex === 6 && vars.isMobile()) {
						isAnimating = false;
					}

					vars.$document.trigger('home-screen-show', screenIndex);

					canInteract(true);
					resolve();
				},
			});

		if (!vars.isMobile()) {
			tl.to($homeScroll, {
				duration: 0.75,
				autoAlpha: 0,
			})
				.set($homeScroll, {
					y: screenPosition,
				})
				.to($homeScroll, {
					duration: 0.75,
					autoAlpha: 1,
				});
		} else {
			tl.from($screenNext, {
				y: '100%',
				clearProps: 'all',
				duration: 1,
				onStart() {
					$screenNext.addClass('is-current is-animated');
				},
				onComplete() {
					$homeScreen.removeClass('is-current');
					$screenNext.removeClass('is-animated');
				},
			});
		}
	});
}

function screenTransitionFromOverlay(screenIndex) {
	return new Promise((resolve) => {
		let $screenCurrent = $homeScreen.filter('.is-current');
		let $screenNext = $screenCurrent;

		const screenCurrentIndex = +$screenCurrent.data('screen');
		const screenPrevIndex = $overlay.data('screen-prev');
		const screenPrevDirection = $overlay.data('screen-direction');

		let direction = screenCurrentIndex > screenPrevIndex ? 1 : -1;

		if (
			screenIndex < screenCurrentIndex && screenPrevDirection > 0 ||
			screenIndex > screenCurrentIndex && screenPrevDirection < 0
		) {
			$screenNext = $homeScreen.filter(`[data-screen="${screenPrevIndex}"]`);

			screenIndex = screenPrevIndex;
			direction = screenIndex > screenCurrentIndex ? 1 : -1;

			$homeScreen.removeClass('is-current');
			$screenNext.addClass('is-current');
		} else {
			screenIndex = screenCurrentIndex;
		}

		const screenPosition = -($screenNext.offset().top - $homeScroll.offset().top);

		if (screenIndex === 6) {
			test.enter(0.5);
		}

		if (screenIndex === 1) {
			$('.entrance').scrollTop(0, 0);
		}

		if (screenIndex === 1 && vars.isMobile()) {
			isAnimating = false;
		}

		if (screenIndex === 5) {
			$('.professions__slide').scrollTop(0, 0);
		}

		let tl = gsap
			.timeline({
				onComplete() {
					$overlay.addClass('is-hidden');
					$overlayIntroImage.addClass('is-hidden');

					if ($overlayBgVideo) {
						$overlayBgVideo.pause();
					}

					gsap.killTweensOf([$overlay, $overlayBg, $overlayImage, $overlayIntro]);
					gsap.set([$overlay, $overlayBg, $overlayImage, $overlayIntro], { clearProps: 'all' });

					changeUrl();

					if (screenIndex === 5) {
						vars.$document.on('professions-slider-update');
					}

					if (screenIndex === 3) {
						vars.$document.trigger('discoveries-slider-play');
					} else {
						vars.$document.trigger('discoveries-slider-stop');
					}

					if (screenIndex === 6 && vars.isMobile()) {
						isAnimating = false;
					}

					vars.$document.trigger('home-screen-show', screenIndex);

					isAnimating = false;

					canInteract(true);
					resolve();
				},
			})
			.set($homeScroll, {
				y: screenPosition,
			})
			.fromTo($overlay, {
				yPercent: 0,
			}, {
				duration: 0.75,
				yPercent: -100 * direction,
			});
	});
}

function screenTransitionToOverlay(screenIndex, direct) {
	return new Promise((resolve) => {
		const $screenCurrent = $homeScreen.filter('.is-current');
		const $screenNext = $homeScreen.filter(`[data-screen="${screenIndex}"]`);

		const screenCurrentIndex = +$screenCurrent.data('screen');

		const direction = screenIndex > screenCurrentIndex ? 1 : -1;

		const $overlayIntroImageCurrent = $overlayIntroImage.filter(`[data-screen="${screenCurrentIndex < screenIndex || direct ? screenIndex : screenCurrentIndex}"]`);

		$overlay
			.removeClass('is-hidden')
			.data({
				screenPrev: screenCurrentIndex,
				screenDirection: direction,
			});

		$overlayIntroImageCurrent.removeClass('is-hidden');

		if ($overlayBgVideo) {
			$overlayBgVideo.currentTime = 0;
			$overlayBgVideo.play();
		}

		gsap.fromTo($overlayIntro, {
			yPercent: 5 * direction,
		}, {
			duration: 5,
			yPercent: 0,
		});

		gsap
			.timeline({
				onComplete() {
					$homeScreen.removeClass('is-current');
					$screenNext.addClass('is-current');

					if (screenCurrentIndex === 6 && screenIndex !== 6) {
						test.leave();
					}

					if (direction > 0 || direct) {
						changeUrl();
					}

					if (screenIndex === 2 || vars.isMobile()) {
						vars.$document.trigger('achievements-slide-first');
					}

					vars.$document.trigger('virtual-hit', screenIndex);

					screenTransitionFromOverlay(screenIndex).then(resolve);

					canInteract(true);
					resolve();
				},
			})
			.fromTo($overlay, {
				yPercent: 100 * direction,
			}, {
				duration: 0.75,
				yPercent: 0,
			})
			.from([$overlayBg, $overlayImage], {
				duration: 0.75,
				yPercent: -50 * direction,
			}, 0)
			.call(() => { }, null, '+=0.5');
	});
}

function screenTransition(screenIndex, withoutOverlay, direct) {
	return new Promise((resolve) => {
		const $screenNext = $homeScreen.filter(`[data-screen="${screenIndex}"]`);

		if (!$screenNext.length) {
			resolve();

			return;
		}

		if ($overlay.hasClass('is-hidden') && $screenNext.hasClass('home__placeholder') && vars.isMobile()) {
			resolve();

			return;
		}

		canInteract(false);

		const $screenCurrent = $homeScreen.filter('.is-current');

		const screenCurrentIndex = +$screenCurrent.data('screen');

		direct = typeof direct === 'undefined' ? Math.abs(screenCurrentIndex - screenIndex) > 1 : direct;
		isAnimating = true;
		screenIndex = +screenIndex;

		if (!withoutOverlay && !$overlay.hasClass('is-hidden')) {
			screenTransitionFromOverlay(screenIndex).then(resolve);
		} else if (
			!withoutOverlay &&
			(
				!direct && screenCurrentIndex < screenIndex && $overlayIntroImage.filter(`[data-screen="${screenIndex}"]`).length ||
				!direct && screenCurrentIndex > screenIndex && $overlayIntroImage.filter(`[data-screen="${screenCurrentIndex}"]`).length ||
				direct && $overlayIntroImage.filter(`[data-screen="${screenIndex}"]`).length
			)
		) {
			screenTransitionToOverlay(screenIndex, direct).then(resolve);
		} else {
			screenTransitionWithoutOverlay(screenIndex).then(resolve);
		}
	});
}

function changeScreen(e) {
	if (!e || isAnimating) {
		return;
	}

	let currentScreenIndex = $homeScreen.filter('.is-current').data('screen');
	let toScreen;
	let touchScroll = touchStartY - touchEndY;

	if (
		(e.deltaY && e.deltaY < 0 || e.keyCode && controlsNext.indexOf(e.keyCode) !== -1 || vars.isMobile() && touchScroll <= -touchPach) &&
		currentScreenIndex < $homeScreen.length
	) {
		toScreen = currentScreenIndex + 1;
	} else if (
		(e.deltaY && e.deltaY > 0 || e.keyCode && controlsPrev.indexOf(e.keyCode) !== -1 || vars.isMobile() && touchScroll >= touchPach) &&
		(!$overlay.hasClass('is-hidden') && currentScreenIndex > 0 || currentScreenIndex > 1)
	) {
		toScreen = currentScreenIndex - 1;
	}

	screenTransition(toScreen);
}

function goToScreenOnBegin() {
	let screenIndex = $homeScreen.filter(`[data-name="${location.hash.substring(1)}"]`).data('screen');

	if (!location.hash || typeof screenIndex === 'undefined') {
		screenIndex = 1;
	}

	screenTransition(screenIndex, true);
}

function createOverlayTouchEvents() {
	const safeZone = 30;

	let clientYStart = null;
	let clientYEnd = null;

	$overlay
		.on('touchstart', (e) => {
			clientYStart = e.originalEvent.changedTouches[0].clientY;
		})
		.on('touchmove', (e) => {
			clientYEnd = e.originalEvent.changedTouches[0].clientY;
		})
		.on('touchend', () => {
			if (
				isAnimating || clientYStart === null || clientYEnd === null ||
				Math.abs(clientYStart - clientYEnd) < safeZone
			) {
				clientYStart = null;
				clientYEnd = null;

				return;
			}

			let screenCurrentIndex = +$homeScreen.filter('.is-current').data('screen');
			let screenIndex = null;

			if (clientYStart > clientYEnd && screenCurrentIndex < $homeScreen.length) {
				screenIndex = screenCurrentIndex + 1;
			} else if (clientYStart < clientYEnd && (!$overlay.hasClass('is-hidden') && screenCurrentIndex > 0 || screenCurrentIndex > 1)) {
				screenIndex = screenCurrentIndex - 1;
			}

			screenTransition(screenIndex);

			clientYStart = null;
			clientYEnd = null;
		});
}

createOverlayTouchEvents();

let winWidth = window.innerWidth;

vars.$window
	.on('touchstart', throttle((e) => {
		touchEndY = e.changedTouches ? e.changedTouches[0].clientY : e.clientY;
		console.log(touchEndY)
	}, 100))
	.on('mousewheel touchend', throttle((e) => {
		const $currentTarget = $(e.target);
		const $currentSection = $currentTarget.closest('.home__section').data('screen');
		const $currentSlide = $currentTarget.closest('.home__section').find('.swiper-slide.swiper-slide-active[data-slide]').data('slide');
		const $currentPopup = $currentTarget.closest('[data-popup="true"]').length;
		const $entr = $currentTarget.closest('.home__section').find('.entrance');
		const $entrScroll = $entr.find('.entrance__content');
		const $profSlide = $currentTarget.closest('.home__section').find('.professions__slide.swiper-slide-active');
		const $profSlideScroll = $profSlide.find('.professions__scroll');
		let $windowHeight = vars.$window.height();
		let $entrScrollHeight = $entrScroll.outerHeight();
		let $entrTop = $entr.scrollTop();
		let $profSlideScrollHeight = $profSlideScroll.outerHeight();
		let $profSlideTop = $profSlide.scrollTop();

		const delta = e.deltaY || e.detail || e.wheelDelta;
		touchStartY = e.changedTouches ? e.changedTouches[0].clientY : e.clientY;

		let touchScroll = touchStartY - touchEndY;

		if (scrollTimeout) {
			scrollTimeout.kill();
		}

		if (isScroll && canScroll) {
			if ($currentPopup) {
				return;
			}

			if ($currentSection === 1) {
				if (vars.isMobile()) {
					isAnimating = true;

					if (isAnimatingNext && $entrScrollHeight - $windowHeight <= $entrTop + 70) {
						isAnimatingNext = false;
						isAnimating = false;
					} else if (!isAnimatingNext && $entrScrollHeight - $windowHeight <= $entrTop + 70) {
						isAnimatingNext = true;
					} else if (isAnimatingNext && $entrScrollHeight - $windowHeight > $entrTop) {
						isAnimatingNext = false;
					}
				} else {
					isAnimating = false;
				}
			}

			if ($currentSection === 2) {
				isAnimating = true;

				if (delta === -1 && $currentSlide < 11 || touchScroll <= -touchPach && $currentSlide < 11) {
					vars.$document.trigger('achievements-slide-next');
				} else if (delta === -1 && $currentSlide === 11 || touchScroll <= -touchPach && $currentSlide === 11) {
					scrollTimeoutMs = 0.4;
					isAnimating = false;
				} else if (delta === 1 && $currentSlide > 1 || touchScroll >= touchPach && $currentSlide > 1) {
					vars.$document.trigger('achievements-slide-prev');
				} else if (delta === 1 && $currentSlide === 1  || touchScroll >= touchPach && $currentSlide === 1) {
					scrollTimeoutMs = 0.4;
					isAnimating = false;
				}
			}

			if ($currentSection === 3) {
				isAnimating = true;

				if (delta === -1 && $currentSlide < 7 || touchScroll <= -touchPach && $currentSlide < 7) {
					vars.$document.trigger('discoveries-slide-next');
				} else if (delta === -1 && $currentSlide === 7 || touchScroll <= -touchPach && $currentSlide === 7) {
					scrollTimeoutMs = 0.4;
					isAnimating = false;
				} else if (delta === 1 && $currentSlide > 1 || touchScroll >= touchPach && $currentSlide > 1) {
					vars.$document.trigger('discoveries-slide-prev');
				} else if (delta === 1 && $currentSlide === 1 || touchScroll >= touchPach && $currentSlide === 1) {
					scrollTimeoutMs = 0.4;
					isAnimating = false;
				}
			}

			if ($currentSection === 4) {
				isAnimating = true;

				if (delta === -1 && $currentSlide < 2 || touchScroll <= -touchPach && $currentSlide < 2) {
					vars.$document.trigger('stories-slide-next');
				} else if (delta === -1 && $currentSlide === 2 || touchScroll <= -touchPach && $currentSlide === 2) {
					scrollTimeoutMs = 0.4;
					isAnimating = false;
				} else if (delta === 1 && $currentSlide > 1 || touchScroll >= touchPach && $currentSlide > 1) {
					vars.$document.trigger('stories-slide-prev');
				} else if (delta === 1 && $currentSlide === 1 || touchScroll >= touchPach && $currentSlide === 1) {
					scrollTimeoutMs = 0.4;
					isAnimating = false;
				}
			}

			if ($currentSection === 5) {
				isAnimating = true;

				if (
					$currentTarget.hasClass('aside--left') ||
					$currentTarget.closest('.aside--left').length ||
					$currentTarget.hasClass('professions__dots') ||
					$currentTarget.closest('.professions__dots').length
				) {
					isAnimating = false;
				} else {
					if (delta === -1 && $currentSlide < 4 && $profSlideScrollHeight - $windowHeight <= $profSlideTop + 30 || vars.isMobile() && touchScroll <= -touchPach && $currentSlide < 4 && $profSlideScrollHeight - $windowHeight <= $profSlideTop + 70) {
						vars.$document.trigger('professions-slide-next');
					} else if (delta === -1 && $currentSlide === 4 && $profSlideScrollHeight - $windowHeight <= $profSlideTop + 30 || vars.isMobile() && touchScroll <= -touchPach && $currentSlide === 4 && $profSlideScrollHeight - $windowHeight <= $profSlideTop + 70) {
						scrollTimeoutMs = 0.4;
						isAnimating = false;
					} else if (delta === 1 && $currentSlide > 1 && $profSlideTop + 30 <= 30 || vars.isMobile() && touchScroll >= touchPach && $currentSlide > 1 && $profSlideTop + 70 <= 70 ) {
						vars.$document.trigger('professions-slide-prev');
					} else if (delta === 1 && $currentSlide === 1  && $profSlideTop + 30 <= 30 || vars.isMobile() && touchScroll >= touchPach && $currentSlide === 1 && $profSlideTop + 70 <= 70 ) {
						scrollTimeoutMs = 0.4;
						isAnimating = false;
					}
				}
			}

			if ($currentSection === 6 && !vars.isMobile()) {
				isAnimating = false;
			} else if ($currentSection === 6 && vars.isMobile() && !isAnimatingTest) {
				isAnimating = true;
			} else if ($currentSection === 6 && vars.isMobile() && isAnimatingTest) {
				isAnimating = false;
			}

			changeScreen(e);
		}

		canScroll = false;

		scrollTimeout = gsap.delayedCall(scrollTimeoutMs, () => {
			canScroll = true;
			scrollTimeoutMs = 0.2;
		});
	}, 100))
	.on('resize', () => {
		setTimeout(() => {
			if (winWidth !== window.innerWidth) {
				scrollStep = innerHeight;

				screenTransition($homeScreen.filter('.is-current').data('screen'), true);

				winWidth = window.innerWidth;
			}
		}, 300);
	});

vars.$document
	.on('keydown', (e) => {
		changeScreen(e);
	})
	.on('scroll-animate-false', () => {
		isAnimating = true;
	})
	.on('scroll-animate-true', () => {
		if (+$homeScreen.filter('.is-current').data('screen') !== 2) {
			isAnimating = false;
		}
	})
	.on('test-animate-false', () => {
		isAnimatingTest = false;
	})
	.on('test-animate-true', () => {
		isAnimatingTest = true;
	});

$headerLink.on('click', (e) => {
	const screenIndex = e.currentTarget.dataset.scroll;

	screenTransition(screenIndex, undefined, true);
});

$asideNext.on('click', (e) => {
	const screenIndex = $(e.currentTarget).closest('.home__section').next().data('screen');

	screenTransition(screenIndex);
});

$asideBack.on('click', () => {
	screenTransition(1);
});

$achievementsTextLink.on('click', (e) => {
	e.preventDefault();
	e.stopPropagation();

	screenTransition(6);
});

$beginButton.on('click', () => {
	goToScreenOnBegin();
});

// let animateScreen = () => {
// 	const $entrance = $('.entrance');
// 	const $entranceYura = $('.entrance__yura');
// 	const $entranceH1Name = $('.entrance__h1--name');
// 	const $entranceH1We = $('.entrance__h1--we');
// 	const $entranceH1Proud = $('.entrance__h1--proud');
// 	const $entranceRect = $('.entrance__rect');
// 	const $entranceTitle = $('.entrance__title');
// 	const $entranceText = $('.entrance__text');

// 	const $professionsDot1 = $('.professions__dot--red');
// 	const $professionsDot2 = $('.professions__dot--blue');
// 	const $professionsDot3 = $('.professions__dot--purple');
// 	const $professionsDot4 = $('.professions__dot--green');

// 	const $professionsSlideTitle = $('.professions__slide.swiper-slide-active .professions__title');
// 	const $professionsSlideLine = $('.professions__slide.swiper-slide-active .professions__line');
// 	const $professionsSlideRect = $('.professions__slide.swiper-slide-active .professions__rect');
// 	const $professionsSlideContext = $('.professions__slide.swiper-slide-active .professions__context');
// 	const $professionsNavigation = $('.professions__navigation');

// 	if (screenIndex === 1 && !vars.isMobile()) {
// 		tl
// 			.from($entranceYura, {
// 				duration: 0.75,
// 				y: '150',
// 				opacity: 0,
// 				clearProps: true,
// 			})
// 			.from($entranceH1Name, {
// 				duration: 0.75,
// 				y: '150',
// 				opacity: 0,
// 				clearProps: true,
// 			}, '<0.35')
// 			.from([$entranceH1We, $entranceH1Proud], {
// 				duration: 0.75,
// 				y: '150',
// 				opacity: 0,
// 				clearProps: true,
// 			}, '<0.35')
// 			.from($entranceRect, {
// 				duration: 0.75,
// 				y: '100',
// 				opacity: 0,
// 				clearProps: true,
// 			}, '<0.25')
// 			.from($entranceTitle, {
// 				duration: 0.75,
// 				y: '100',
// 				opacity: 0,
// 				clearProps: true,
// 			}, '<0.25')
// 			.from($entranceText, {
// 				duration: 0.75,
// 				y: '100',
// 				opacity: 0,
// 				clearProps: true,
// 			}, '<0.15');
// 	}

// 	if (screenIndex === 2 && !vars.isMobile()) {
// 		tl
// 			.from($professionsDot1, {
// 				duration: 0.5,
// 				x: '-150%',
// 				ease: 'circ.out',
// 			})
// 			.from($professionsDot2, {
// 				duration: 0.5,
// 				x: '-150%',
// 				ease: 'circ.out',
// 			}, '<0.1')
// 			.from($professionsDot3, {
// 				duration: 0.5,
// 				x: '-150%',
// 				ease: 'circ.out',
// 			}, '<0.1')
// 			.from($professionsDot4, {
// 				duration: 0.5,
// 				x: '-150%',
// 				ease: 'circ.out',
// 			}, '<0.1')
// 			.from($professionsSlideTitle, {
// 				duration: 0.5,
// 				y: '100',
// 				opacity: 0,
// 				clearProps: true,
// 			}, '>-0.5')
// 			.from($professionsSlideLine, {
// 				duration: 0.5,
// 				y: '100',
// 				opacity: 0,
// 				clearProps: true,
// 			}, '<0.2')
// 			.from($professionsSlideRect, {
// 				duration: 0.5,
// 				width: '0%',
// 				clearProps: true,
// 			})
// 			.from($professionsSlideContext, {
// 				duration: 0.5,
// 				y: '100',
// 				opacity: 0,
// 				clearProps: true,
// 			}, '>-0.8')
// 			.from($professionsNavigation, {
// 				duration: 0.5,
// 				y: '100',
// 				opacity: 0,
// 				clearProps: true,
// 			}, '>-0.5');
// 	}

// 	if (screenIndex === 3 && !vars.isMobile()) {
// 		tl
// 			.from($storiesSlideBg, {
// 				duration: 0.75,
// 				y: '50vw',
// 				clearProps: true,
// 			})
// 			.from($entranceH1Name, {
// 				duration: 0.75,
// 				y: '150',
// 				opacity: 0,
// 				clearProps: true,
// 			}, '<0.35')
// 			.from([$entranceH1We, $entranceH1Proud], {
// 				duration: 0.75,
// 				y: '150',
// 				opacity: 0,
// 				clearProps: true,
// 			}, '<0.35')
// 			.from($entranceRect, {
// 				duration: 0.75,
// 				y: '100',
// 				opacity: 0,
// 				clearProps: true,
// 			}, '<0.25')
// 			.from($entranceTitle, {
// 				duration: 0.75,
// 				y: '100',
// 				opacity: 0,
// 				clearProps: true,
// 			}, '<0.25')
// 			.from($entranceText, {
// 				duration: 0.75,
// 				y: '100',
// 				opacity: 0,
// 				clearProps: true,
// 			}, '<0.15');
// 	}
// }